Bingo.ActiveState = {};

/**
 * Creates synchronization of class="active" on given selector according to checkbox nested in it.
 * @param selector
 */
Bingo.ActiveState.byNestedCheckbox = function (selector) {
    $(selector).each((index, item) => {
        const inputs = $(item).find('input[type=checkbox]');
        if (inputs.length === 0) {
            return;
        }
        const input = inputs[0];
        $(input).change(() => {
            if (input.checked) {
                $(item).addClass('active-choice');
                $(item).addClass('btn-raised');
                $(item).removeClass('inactive-choice');
            } else {
                $(item).removeClass('active-choice');
                $(item).removeClass('btn-raised');
                $(item).addClass('inactive-choice');
            }
        });
        $(input).change();
    });
};

/**
 * Creates synchronization of class="active" on given selector according to radio input nested in it.
 * Note: automatically resets the class on all inputs of same name inside the same form.
 * @param selector
 */
Bingo.ActiveState.byNestedRadio = function (selector) {
    $(selector).each((index, item) => {
        const inputs = $(item).find('input[type=radio]:not(data-active-state-initialized)');
        if (inputs.length === 0) {
            return;
        }
        inputs.each((inputIndex, input) => {
            $(input).attr('data-active-state-initialized', true);
            const temp = function () {
                if (input.checked) {
                    $(input).closest('.radio-button').find('.btn').each(function () {
                        $(this).addClass('inactive-choice');
                        $(this).removeClass('active-choice');
                        $(this).removeClass('btn-raised');
                    });
                    $(input).closest('.btn').addClass('active-choice');
                    $(input).closest('.btn').addClass('btn-raised');
                    $(input).closest('.btn').removeClass('inactive-choice');
                }
            };
            const readOnly = $(input).attr('readonly');
            if (readOnly) {
                temp();
            } else {
                $(input).change(temp);
                $(input).change();
            }
        });
    });
};
